const prefix = <const T extends string>(id: T) => `Surveys.${id}` as const

export type SimpleUpDownRatingTitle =
  | 'AppExperience'
  | 'CardValue'
  | 'CardRedemptions'
  | 'Support'
  | 'PartnersAndBenefits'

export type SurveysE2EUser = {
  Email: string
  FirstName: string
  LastName: string
  PhoneNumber: string
}

export const SurveysE2E = {
  Users: {
    General: {
      Email: '77aa13e6-d108-4eac-a31e-ef59cb9662f7@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Surveys General',
      PhoneNumber: '(524) 600-3469',
    } as const satisfies SurveysE2EUser,
  },
  Ids: {
    Press: {
      RatingBar: (rating: number) => prefix(`Press.RatingBar#${rating}`),
      SimpleUpDownRating: (title: SimpleUpDownRatingTitle, rating: -1 | 1) =>
        prefix(`Press.SimpleUpDownRating#${title}#${rating}`),
      SubmitOverallRating: prefix('Press.SubmitOverallRating'),
      SubmitDetailedRating: prefix('Press.SubmitDetailedRating'),
      SubmitAdditionalComments: prefix('Press.SubmitAdditionalComments'),
      DialogClose: prefix('Press.DialogClose'),
      ThankYouDismiss: prefix('Press.ThankYouDismiss'),
    },
    View: {
      DialogOverlay: prefix('View.DialogOverlay'),
      RatingBar: prefix('View.RatingBar'),
      OverallRating: prefix('View.OverallRating'),
      ThankYou: prefix('View.ThankYou'),
      DetailedRating: prefix('View.DetailedRating'),
      AdditionalComments: prefix('View.AdditionalComments'),
    },
    Input: {
      AdditionalComments: prefix('Input.AdditionalComments'),
    },
  },
} as const
